import type { CompanyStatus, SubmissionStatus } from '../lib/types.ts';
import { COMPANY_STATUS_LABELS } from '../lib/companyStatus.ts';

const COMPANY_CLS: Record<CompanyStatus, string> = {
  invited: 'bg-slate-100 text-slate-700',
  in_progress: 'bg-blue-50 text-blue-700',
  review: 'bg-amber-50 text-amber-700',
  changes: 'bg-orange-50 text-orange-700',
  compliant: 'bg-emerald-50 text-emerald-700',
  expired: 'bg-red-50 text-red-700',
  deactivated: 'bg-slate-200 text-slate-600',
};

const SUBMISSION_LABELS: Record<SubmissionStatus, { label: string; cls: string }> = {
  pending: { label: 'Pending', cls: 'bg-slate-100 text-slate-700' },
  approved: { label: 'Compliant', cls: 'bg-emerald-50 text-emerald-700' },
  rejected: { label: 'Not Compliant', cls: 'bg-orange-50 text-orange-700' },
  not_applicable: { label: 'N/A', cls: 'bg-slate-100 text-slate-600' },
};

export function CompanyStatusBadge({ status }: { status: CompanyStatus }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${COMPANY_CLS[status]}`}
    >
      {COMPANY_STATUS_LABELS[status]}
    </span>
  );
}

export function SubmissionStatusBadge({ status }: { status: SubmissionStatus }) {
  const cfg = SUBMISSION_LABELS[status];
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${cfg.cls}`}
    >
      {cfg.label}
    </span>
  );
}
